import React from "react";
import Power from "../utilities/Power";
import { generateInitials } from "../user/UserProfile";
import { useParams } from "react-router-dom";

function StartMenu({
  toggleStart,
  isStartOpen,
  setInput,
  setIsSleeping,
  setActionType,
}) {
  const { name } = useParams();
  return (
    <>
      <section
        id="w11-start-section"
        className={`z-50 bg-neutral-800 ${
          isStartOpen ? "bottom-16" : "bottom-[-800px]"
        }`}
      >
        <div className="input-div-start">
          <input
            type="text"
            id="cerca-input-start"
            placeholder="Search for apps, settings, and documents"
            disabled={isStartOpen ? false : true}
          />
        </div>
        <div className="padding-start">
          <div id="apps-container">
            <div className="app-container-header">
              <span>Pinned</span>
              <div>
                <span>All apps</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="rgba(0, 0, 0, 1)"
                >
                  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                </svg>
              </div>
            </div>
            <div id="second-app-container">
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/themes/Yaru/system/ignitia.svg"
                  alt="Ignitia icon"
                />
                <span>Ignitia 2k25</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/word-icon.png"
                  alt="word icon"
                />
                <span>Word</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/excel-icon.png"
                  alt="excel icon"
                />
                <span>Excel</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/powerpoint-icon.png"
                  alt="powerpoint icon"
                />
                <span>Powerpoint</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/ms-office.ico"
                  alt="office icon microsoft"
                />
                <span>Office</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/calendar-icon.png"
                  alt="calendar icon"
                />
                <span>Calender</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/ms-store-icon.png"
                  alt="microsoft store icon"
                />
                <span>Microsoft Store</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/ms-foto-icon.ico"
                  alt="galleria icon by microsoft 11"
                />
                <span>Photos</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/ms-video-icon.ico"
                  alt="microsoft video icon by microsoft"
                />
                <span>Film & TV</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/Paint-2D.ico"
                  alt="paint 2d icon by microsoft"
                />
                <span>Paint</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/Paint-3D.ico"
                  alt="paint 2d icon by microsoft"
                />
                <span>Paint 3D</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/Whiteboard.ico"
                  alt="whiteboard icon by microsoft"
                />
                <span>WhiteBoard</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/ms-impostazioni-icon.ico"
                  alt="impostazioni icon by microsoft"
                />
                <span>Settings</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/images/logos/logo.png"
                  alt="Studex icon by Shivam"
                />
                <span>Skudex Portal</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/vs-code.ico"
                  alt="vs code icon by microsoft"
                />
                <span>VS code</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/themes/Yaru/apps/linkedin.png"
                  alt="Linkedin Icon"
                />
                <span>Linkedin</span>
              </div>
              <div className="app-icon">
                <img
                  src="https://v1.itshivam.me/assets/ms-file-explorer.ico"
                  alt="file Explorer icon by microsoft"
                />
                <span>File Explorer</span>
              </div>
            </div>
          </div>
          <div id="article-div">
            <div className="app-container-header">
              <span>Recommended</span>
              <div>
                <span>More</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="rgba(0, 0, 0, 1)"
                >
                  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                </svg>
              </div>
            </div>
            <div id="article-container">
              <div className="recent">
                <div>
                  <img
                    src="https://v1.itshivam.me/assets/vs-code.ico"
                    alt="VS code icon"
                  />
                </div>
                <div>
                  <div>VS Code</div>
                  <div>Recently added</div>
                </div>
              </div>
              <div className="recent">
                <div>
                  <img
                    src="https://v1.itshivam.me/themes/Yaru/system/ignitia.svg"
                    alt="Ignitia Icon"
                  />
                </div>
                <div>
                  <div>Ignitia 2k25</div>
                  <div>Recently added</div>
                </div>
              </div>
              <div className="recent">
                <div>
                  <img
                    src="https://v1.itshivam.me/assets/Photos-folder.ico"
                    alt="folder microsoft"
                  />
                </div>
                <div>
                  <div>System Design</div>
                  <div>30 minutes ago</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="footer-start-section">
          <div className="nome-utente-start-section">
            <div className="avatar placeholder">
              <div className="bg-blue-500 text-white rounded-full w-8">
              {name && (
  <div className="flex items-center gap-2">
    <img
      src="https://assets.itshivam.me/1.png"
      alt={`${name}'s profile`}
      className="w-10 h-10 rounded-full" 
    />
    <div className="text-white text-xl font-normal">
      {generateInitials(name)}
    </div>
  </div>
)}

              </div>
            </div>
            <div>
              {name ? <div className="capitalize">{name}</div> : "User"}
            </div>
          </div>
          <div className="spegni-pc-start-section">
            <Power
              toggleStart={toggleStart}
              setInput={setInput}
              setIsSleeping={setIsSleeping}
              setActionType={setActionType}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default StartMenu;
